import React from "react";
// import InputSearch from "../../../FormElements/inputSearch";
// import SelectAdviser from "../../../selectAdviser";

import SelectAdviser from "../../../Components/selectAdviser";
import InputSearch from "../../../Components/FormElements/inputSearch";

export const InputsSearchBy = ({handleChangeState, channel, params, setParams, selectedOption, setSelectedOption, options, searchInput, handleChangeSearch, handleChangeSelect}: any) => {
  const validateChannel = ['suscriptor', 'admin', 'adminfull'];

  const switchStyle = validateChannel.includes(channel) ? 'content-form-ad' : 'content-form';

  return (
    <>
      <div className={switchStyle}>
        <select onChange={handleChangeState}>
          <option value={"todas"}>Todas</option>
          <option value={"vigentes"}>Vigentes</option>
          <option value={"vencidas"}>Vencidas</option>
        </select>

        {validateChannel.includes(channel) && (
          <SelectAdviser params={params} setParams={setParams} selectedOption={selectedOption} setSelectedOption={setSelectedOption}/>
        )}

        <InputSearch
          values={options}
          value={searchInput}
          onChangeInput={handleChangeSearch}
          onChangeSelect={handleChangeSelect}
        />
      </div>
    </>
  );
};
